/**
 * Created by tschenkel on 10/30/2015.
 */

import { TestEnvironment } from "./TestEnvironment";

export class LocalHostTestEnvironment extends TestEnvironment {
    public static LOCAL_HOST_ENVIRONMENT_ID: string = "LocalHostTestEnvironment";

    constructor() {
        super(LocalHostTestEnvironment.LOCAL_HOST_ENVIRONMENT_ID);
    }

    public initPatterns(): void {
        super.initPatterns();

        this._branchesConfigPathPattern = "../../branches/{gameFileName}/branches.xml";
        this._gameUrlPathPattern = "../../branches/{gameFileName}/{branchId}/{gameTitle}Game_{branchVersion}.swf";
    }

    public isSupported(): boolean {
        return this._data.globals.isLocalHost;
    }
}
